import { mutations as TYPES } from "./types";
// import {
//   defaultState
// } from "./state";
// eslint-disable-next-line no-unused-vars
import i18n, { loadLanguageAsync } from "@/i18n.js";
import Cookie from "@/utils/cookie";
import { GEM_LANG_COOKIE_NAME } from "@/config/constants/common";
// import { FETCH } from "@/utils/list";

const mutations = {
  // [TYPES.ACCOUNT_RESET](state) {
  //   state = defaultState();
  // },
  [TYPES.UPDATE_LIMITATION_SUB_PAGE_ALERT](state, page) {
    state.limitationAlert[page] = true;
  },

  [TYPES.ACCOUNT_UPDATE_SHOP_INFO](state, info) {
    let shopInfo = {};
    if (info.profile?.type == "account") {
      if (info.profile?.fname) shopInfo.firstName = info.profile.fname;
      if (info.profile?.lname) shopInfo.lastName = info.profile.lname;
      if (info.profile?.language) shopInfo.language = info.profile.language;
      if (info.profile?.email) shopInfo.email = info.profile.email;
      if (info.profile?.ref) shopInfo.ref = info.profile.ref;
    }
    if (info.profile?.type == "password") {
      shopInfo.password = info.profile.password;
    }
    if (info.emailPreferences) {
      if (!state.shopInfo.accountInfo) {
        state.shopInfo.accountInfo = {
          emailPreferences: {},
          webAnalyticsTools: {}
        };
      }
      state.shopInfo.accountInfo.emailPreferences = {
        ...state.shopInfo.accountInfo.emailPreferences,
        ...info.emailPreferences
      };
    }
    if (info.webAnalyticsTools) {
      if (!state.shopInfo.accountInfo) {
        state.shopInfo.accountInfo = {
          emailPreferences: {},
          webAnalyticsTools: {}
        };
      }
      state.shopInfo.accountInfo.webAnalyticsTools = {
        ...state.shopInfo.accountInfo.webAnalyticsTools,
        ...info.webAnalyticsTools
      };
    }
    if (info.type == "store") {
      state.shopInfo.storeInfo = {
        ...state.shopInfo.storeInfo,
        ...info
      };
    }

    Object.keys(shopInfo).forEach(key => {
      state.shopInfo[key] = shopInfo[key];
    });
    const isGemPagesV7 = (state.shopInfo?.isGemPagesV7 || '').toString() === "true";
    state.shopInfo = {
      ...state.shopInfo,
      shopType: {
        isGemPagesV6: state.shopInfo?.isGemPagesV7 == "false",
        isGemPagesV7: state.shopInfo?.isGemPagesV7 == "true",
        isGemPagesMixed: state.shopInfo?.isGemPagesV7 == "mixed"
      },
      isGemPagesV7: isGemPagesV7,
      gemVersion: isGemPagesV7 ? 'v7' : 'v6'
    }
  },

  [TYPES.ACCOUNT_ATTACH](state, auth) {
    if (!auth) return;
    const setPermission = (sub = false, home = false, collection = false, product = false, article = false, analytics = false, headerFooter = false) => {
      return {
        subpages: sub, // landing
        homepages: home, // home
        collectionpages: collection, // colec
        productpages: product, // produc
        articlepages: article, // blog
        analytics, // abtest
        headerFooter
      };
    };

    let permission = setPermission();

    if (!auth.language) {
      auth.language = process.env.VUE_APP_I18N_LOCALE ?? "en";
    }

    if (!state.shopInfo)
      state.shopInfo = {
        ...auth,
      };
    else
      Object.keys(auth).forEach(key => {
        state.shopInfo[key] = auth[key];
      });
    // state.shopInfo.plan = "build";
    switch (auth.plan) {
      case "trial":
        if (auth.remainingDays > 0) {
          permission = setPermission(true, true, true, true, true);
        }
        break;

      case "starter":
        permission = setPermission(true, true);
        break;

      case "professional":
      case "advanced":
      case "optimize":
      case "enterprise":
      case "build":
      case "plus": {
        permission = setPermission(true, true, true, true, true, true);
        break;
      }

      default:
        permission = setPermission();
        break;
    }

    // logic check from BE
    const limitation = auth?.developmentStore
    ? auth?.planLimitation[auth?.planDevelopmentStore]
    : auth?.planLimitation[auth?.plan];
    // const limitation = auth.planLimitation ? auth.planLimitation[auth.plan] : null;
    if (limitation) {
      const { pageCreate, conversionOptimization, landingPage } = limitation;

      permission = setPermission(pageCreate.templatePage, pageCreate.templateIndex, pageCreate.templateCollection, pageCreate.templateProduct, pageCreate.templateArticle, conversionOptimization?.abTesting?.enabled, landingPage?.hiddenHeaderFooter?.enabled);
      // if ((auth.plan === "trial" || auth.plan === "trial2022") && auth.remainingDays <= 0) {
      //   permission = setPermission();
      // }
    }

    try {
      auth.globalConfigs = JSON.parse(auth.globalConfigs);
    } catch (error) {
      // do smthing
      // eslint-disable-next-line no-console
      console.error("Cannot parse global configs: " + error);
    }

    loadLanguageAsync(auth.language).finally(() => {
      Cookie.set(GEM_LANG_COOKIE_NAME, i18n.locale, 2592000); // equivalent to 30 days
    });

    state.permissions = permission;
    state.hideLanguage = false;
    const isGemPagesV7 = (state.shopInfo?.isGemPagesV7 || '').toString() === "true";
    state.shopInfo = {
      ...state.shopInfo,
      shopType: {
        isGemPagesV6: state.shopInfo?.isGemPagesV7 == "false",
        isGemPagesV7: state.shopInfo?.isGemPagesV7 == "true",
        isGemPagesMixed: state.shopInfo?.isGemPagesV7 == "mixed"
      },
      isGemPagesV7,
      gemVersion: isGemPagesV7 ? 'v7' : 'v6'
    }
  },

  [TYPES.ACCOUNT_UPDATE_STATUS](state, { loading = false, success = false, error = false }) {
    state.status.loading = loading;
    state.status.success = success;
    state.status.error = error;
  },
  [TYPES.ACCOUNT_UNLINK_STATUS](state, { loading = false, success = false, error = false }) {
    state.unlinkStatus.loading = loading;
    state.unlinkStatus.success = success;
    state.unlinkStatus.error = error;
  },

  // [TYPES.ACCOUNT_CHANGE_LANGUAGE](state, lang) {
  //   i18n.locale = lang;
  //   Cookie.set(GEM_LANG_COOKIE_NAME, lang, 2592000); // equivalent to 30 days
  // },
  // [TYPES.ACCOUNT_CANCEL_CHANGE_LANGUAGE](state) {
  //   if (!state.hideLanguage) {
  //     let lang = state.shopInfo.language;
  //     if (i18n.locale != lang) i18n.locale = lang;
  //     Cookie.set(GEM_LANG_COOKIE_NAME, lang, 2592000); // equivalent to 30 days
  //   }
  // },

  [TYPES.ACCOUNT_REMOVE_AGENCY_LOGO](state) {
    state.shopInfo.hasAgency = false;
    state.shopInfo.agency = {};
  },
  [TYPES.ACCOUNT_UPDATE_GOOGLE_AUTH](state, data) {
    state.shopInfo.gaLoggedIn = data;
    if (data == false) {
      if (state?.shopInfo?.accountInfo?.webAnalyticsTools?.ga) {
        const source = state.shopInfo.accountInfo.webAnalyticsTools.ga;
        source.gaAccountId = null;
        source.gaPropertyId = null;
        source.gaViewId = null;
      }
    }
  },
  [TYPES.ACCOUNT_UPDATE_GETHELP_DATA](state, data) {
    state.gethelp = data;
  },
  SET_GLOBAL_CONFIGS(state, globalConfigs) {
    if (state.shopInfo) {
      state.shopInfo.globalConfigs = globalConfigs;
    } else {
      state.shopInfo = {
        globalConfigs
      };
    }
  },
  SHOW_PLAN_MODAL(state, isShow = true) {
    state.showPlanPopup = isShow;
  },
  IS_MODAL_VIEWING(state, isView = false) {
    state.isModalPopup = isView;
  },
  [TYPES.SET_INSTANT_SHOP_ID](state, id) {
    state.instantShopId = id;
  },
  [TYPES.SET_INSTANT_SHOP_TOKEN](state, token) {
    state.instantShopToken = token;
  }
  // [TYPES.ACCOUNT_FETCH_LANGUAGES](state, { list, reset }) {
  //   if (!list || !list.length) return;
  //   let comparer = (obj, item) => {
  //     return obj.id == item.id;
  //   };
  //   if (reset) {
  //     state.language.list = [];
  //   }

  //   FETCH(state.language.list, list, comparer, null);
  // },
};

export default mutations;
